import React, { useState } from "react";
import "./dogs.css";

function Dogs() {
  const [openDog, setOpenDog] = useState(null);

  const dogs = [
    {
      src: "https://i.imgur.com/3lwMDud.jpeg",
      name: "Porter",
      funFact:
        "Porter is our handsome, well-behaved young boy, and we’ve had the pleasure of caring for him since September 2025.",
    },
    {
      src: "https://i.imgur.com/oVSQX5Y.jpeg",
      name: "Duke",
      funFact:
        "Duke joined the crew toward the end of 2025. He’s a little tough at home, but once we’re at the park, we’re besties.",
    },
    {
      src: "https://i.imgur.com/NkVAcbR.jpeg",
      name: "Luna",
      funFact:
        "Luna has been with us since 2022! Kubra’s love for golden retrievers is unmatched, and we’ve loved spending so many holidays with her.",
    },
    {
      src: "https://i.imgur.com/tsp8jqi.jpeg",
      name: "Bagel",
      funFact:
        "Bagel has been part of our pack since 2022. His favorite walker is Zack, and he never hesitates to make that clear to Kubra.",
    },
    {
      src: "https://i.imgur.com/nbEnL0R.jpeg",
      name: "Maggi",
      funFact:
        "Maggi has been part of our lives for three years, since she was just 11 weeks old. She’s the pup we’ve cared for the most, and over time, it truly feels like a co-parenting relationship.",
    },
    {
      src: "https://i.imgur.com/oHBzccx.jpeg",
      name: "Ziggy",
      funFact:
        "Ziggy has been with us since October 2025, and he lights up every time he sees his friends!",
    },
    {
      src: "https://i.imgur.com/OK5rXHD.jpeg",
      name: "Kona",
      funFact:
        "Kona has been part of the crew since August 2025. He always tilt his head from side to side when he listens—it never gets old!",
    },
    {
      src: "https://i.imgur.com/TLvlnTW.jpeg",
      name: "Melo",
      funFact:
        "Melo, our sweet Beagle rescued from a research lab since 2024, has stolen our hearts and we adore his humans just as much!",
    },
    {
      src: "https://i.imgur.com/j3r4PX4.jpeg",
      name: "Waffle",
      funFact:
        "Waffle has been with us since May 2025 and is the absolute fluffiest Bernedoodle in the crew—we love every bit of her!",
    },
    {
      src: "https://i.imgur.com/ozD8IKF.jpeg",
      name: "Apollo",
      funFact:
        "Apollo joined us in the summer of 2025 as a tiny 12-week-old, and he’s been the most energetic pup in the crew ever since!",
    },
    {
      src: "https://i.imgur.com/16a2FFS.jpeg",
      name: "Piper",
      funFact:
        "Piper has been our coziest girl since October 2024! She loves her backyard so much that it’s a challenge to convince her to keep the door closed in winter.",
    },
    {
      src: "https://i.imgur.com/vhVS34E.jpeg",
      name: "Rumi & Sparky",
      funFact:
        "Rumi and Sparky have been part of the crew since October 2024. Rumi shows her love with excited little nips, while Sparky is always ready for an adventure—except on rainy days!",
    },
    {
      src: "https://i.imgur.com/4utX2u5.jpeg",
      name: "Tuck",
      funFact:
        "Tuck has been with us since 2023. He loves his long walks and is hilariously dramatic when it’s time to go back home afterward!",
    },
    {
      src: "https://i.imgur.com/EFkZII8.jpeg",
      name: "Milo",
      funFact:
        "Milo, our sweet little boy since September 2025, would pick cuddles over walks any day!",
    },
    {
      src: "https://i.imgur.com/Xo0Ei5u.jpeg",
      name: "Remi",
      funFact:
        "Remi has been with us since April 2025. This sweet Aussiedoodle with gorgeous eyes greets us with pure joy every time we pick him up!",
    },
    {
      src: "https://i.imgur.com/cfouoXB.jpeg",
      name: "Teddy",
      funFact:
        "Teddy, our first Corgi, has been with us since February 2025. He loves chasing his friend Tuck and is always ready for a treat!",
    },
    {
      src: "https://i.imgur.com/2qHbyL6.jpeg",
      name: "Togo",
      funFact:
        "Togo has been our famous Akita since 2022—it’s nearly impossible to walk him without someone asking how much he weighs, and he holds a very special place in our hearts.",
    },
    {
      src: "https://i.imgur.com/kfPt0Ka.jpeg",
      name: "Nomad",
      funFact:
        "Nomad was our tiny, sweet teacup Maltipoo. Kubra absolutely adored him and his siblings Panda & Petal and when his family moved across the country, it was really hard to say goodbye—she’s still hoping to visit them in San Francisco one day.",
    },
    {
      src: "https://i.imgur.com/bIMfocx.jpeg",
      name: "Poppy",
      funFact:
        "Poppy’s been part of the crew since 2024, and she’s equal parts crazy and sweet. She tries so hard to be the best girl, and her energy is truly unmatched 🫶🏼",
    },
    {
      src: "https://i.imgur.com/zMlwP0E.jpeg",
      name: "Maverick",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/6mWMtvz.jpeg",
      name: "Luna",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/JiAkRZj.jpeg",
      name: "Melon",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/npQVnru.jpeg",
      name: "Rosie",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/SfStx4z.jpeg",
      name: "George",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/O0Gwysr.jpeg",
      name: "Louie",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/RMhEmr8.jpeg",
      name: "Kenan",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/xF2pIJ1.jpeg",
      name: "Layla",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/nzKCRxq.jpeg",
      name: "Jeter & Judge",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/OXOVREm.jpeg",
      name: "Rocket",
      funFact:
        "",
    },
    {
      src: "https://i.imgur.com/j2a2Yo0.jpeg",
      name: "Pebbles",
      funFact:
        "",
    },
  ];

  return (
    <>
      <h1 className="header-dogs">Meet the Pack</h1>

      <div className="slider-scroll-dogs">
        {dogs.map((dog) => (
          <div
            className="dog-wrapper"
            key={dog.src}
            onClick={() => setOpenDog(openDog === dog.src ? null : dog.src)}
          >
            <img src={dog.src} alt={dog.name} className="dog-images" />
            <span className="dog-name">{dog.name}</span>

            {openDog === dog.src && (
              <div className="dog-card fade-in-5">
                <p className="dog-name-2">{dog.name}</p>
                <p className="dog-fact">{dog.funFact}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

export default Dogs;
